// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tabs-header .text-xl{color:#000!important}.tabs-header .active{color:var(--accent-blue)!important}.tabs-header .active:before{transform:scaleX(1)}@media only screen and (max-width:365px){.tabs-header .text-xl{font-size:1rem;line-height:1.5rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
